import React from "react";
import { SanityRawContent } from "../../model/common";
import BlockContent from "../BlockContent/BlockContent";
import styles from "./StyledContent.module.scss";

export interface SanityStyledContent {
  style: "splash" | "normal";
  content: SanityRawContent;
  _key?: string;
}

interface StyledContentProps {
  node: SanityStyledContent;
}

export const StyledContent = ({
  node: { content, style }
}: StyledContentProps) => {
  return <BlockContent className={styles[style]} content={content} />;
};

export default StyledContent;
